import { createSlice } from '@reduxjs/toolkit'

const InitState = {
        email:'',
        name: '',
        password:'',
        token: '',
        loading:false
}

export const loginSlice  = createSlice({
    name:'login',
    initialState : InitState,
    reducers:{
        loginState:(state,action)=>{
            state[action.payload.name] = action.payload.value;
            state.loading = false;
        },
        clearUserData: (state) => {
            state.token = ''
            state.email = ''
            state.password = ''
            state.name = ''
            state.loading = false
            localStorage.clear()
        },
         setLoader: (state, action) => {
            state.loading = action.payload.data
          },
    },
})

export const { loginState, clearUserData, setLoader } = loginSlice.actions

export default loginSlice.reducer   